module.exports = __webpack_public_path__ + "img/FLSH5.c2795231.svg";